import {
  graphicHeaderDefaults,
  standardHeaderDefaults
} from 'factories/header';
import { useSelector } from 'react-redux';
import { State } from 'store/store';

const getHeaderElement = (blocks, element) => {
  return element ? blocks[element.id] : {};
};

export const useHeader = () => {
  const header = useSelector((state: State) => {
    return getHeaderElement(state.blocks, state.header);
  });

  const standardHeader = useSelector((state: State) => {
    return getHeaderElement(state.blocks, state.standardHeader);
  });

  const graphicHeader = useSelector((state: State) => {
    return getHeaderElement(state.blocks, state.graphicHeader);
  });

  const standardHeaderLogo = useSelector((state: State) => {
    return getHeaderElement(state.blocks, state.standardHeaderLogo);
  });

  const graphicHeaderBackground = useSelector((state: State) => {
    return getHeaderElement(state.blocks, state.graphicHeaderBackground);
  });

  const graphicHeaderLogo = useSelector((state: State) => {
    return getHeaderElement(state.blocks, state.graphicHeaderLogo);
  });

  return {
    block: header,
    props: {
      headerStyle: 'standard',
      ...header!.props,
    },

    standard: {
      block: standardHeader,
      props: {
        ...standardHeaderDefaults,
        ...standardHeader.props,
        headerLogo: standardHeaderLogo?.props?.src,
      },
      logoBlock: standardHeaderLogo,
    },
    graphic: {
      block: graphicHeader,
      props: {
        ...graphicHeaderDefaults,
        ...graphicHeader.props,
        headerBackgroundImage: graphicHeaderBackground?.props?.src,
        headerLogo: graphicHeaderLogo?.props?.src,
      },
      backgroundBlock: graphicHeaderBackground,
      logoBlock: graphicHeaderLogo,
    },
  } as any;
};
